<template>
    <!-- Main Content Start -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Expenses Report</h2>
        </div>
        
       <!-- Filter Form -->
<div class="card p-4 mb-4">

        <div class="flex flex-col lg:flex-row lg:items-center lg:space-x-4 space-y-4 lg:space-y-0">

            <div class="w-full lg:w-auto ml-2 mt-4">
                <label for="from_branch" class="block text-sm font-medium text-gray-700">Search Ledger</label>
                <select class="form-input w-full p-2 border border-gray-300 rounded" id="from_branch" ref="from_branch" v-model="filter.ledger">
                    <option value=""></option>
                    <option value="All">ALL</option>
                    <option v-for="(item, index) in ledgerList" :key="index" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
            
          <!-- Start Date -->
          <div class="w-full lg:w-auto mt-4">
            <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
            <input type="date" id="startDate" v-model="filter.fromdate" class="p-2 border border-gray-300 rounded w-full" />
        </div>
        
        <!-- End Date -->
        <div class="w-full lg:w-auto ml-2">
            <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
            <input type="date" id="endDate" v-model="filter.todate" class="p-2 border border-gray-300 rounded w-full" />
        </div>

         <!-- Filter Button -->
         <div class="w-50 lg:w-auto ml-2">
            <button type="submit" @click="getBasicFilteredData" class="btn b-solid btn-primary-solid px-5 cursor-pointer w-full lg:w-auto mt-2 lg:mt-6">Filter</button>
        </div>  
            <!-- Vendor Filter -->
        
            
            <!-- Product Filter -->
            <!-- <div class="w-full lg:w-auto ml-2" style="width: 150px;">
                <label for="to_branch" class="block text-sm font-medium text-gray-700">Search To Branch</label>
                <select class="form-input w-full p-2 border border-gray-300 rounded" id="to_branch" ref="to_branch" v-model="sale.to_branch">
                    <option value=""></option>
                    <option value="All">ALL</option>
                    <option v-for="(item, index) in branchList" :key="index" :value="item.name">{{ item.name }}</option>
                </select>
            </div> -->
            
           
        </div>

</div> 

<div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">
    <button @click="exportCSV" class="w-full lg:w-auto btn btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer">
        Export
    </button>
    &nbsp;&nbsp;&nbsp;
                <button
                    type="reset"
                    @click="printReceipt"
                    class="w-full lg:w-auto btn btn-success-solid px-5 mt-2 lg:mt-6 cursor-pointer"
                >
                    Print </button>
</div>   
            <div class="printonly">
                 <h4 class="dn_f_only text-center print_heading"><strong>Zambre Patil Prayog Parivar</strong></h4>
                <h4 class="dn_f_only text-center ">From {{startDate}} To {{endDate}}</h4>
            </div>


        <!-- Table Content -->
        <div class="grid grid-cols-12">
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="  space-y-4 overflow-x-auto">
                        <div  class="text-center"  >
                            <h4><b>{{  selectedMukkadamName }}</b></h4>
                        </div>
                    </div>
                    <div class="p-6 space-y-4">
                        <h1 class="text-center"><strong>Profit / Loss Account</strong></h1>
                        <table id="" class="">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Expenses</th>
                                    <th class="bg-[#B2E8D9]">Income</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr>
                                    <td style="align-content: start;">
                                        <table>  
                                            <tr  v-for="(item, index) in expenses_data" :key="item.id"> 
                                                    <td>{{ item.group_name }}</td>
                                                    <td>{{ formatIndianNumber(item.total_amount) }}</td>
                                            </tr>  
                                        </table>
                                        
                                        </td>
                                    <td style="align-content: start;">
                                        <table>
                                            <tr  v-for="(item, index) in income_data" :key="item.id">
                                                    <td>{{ item.product_name }}</td>
                                                    <td>{{ formatIndianNumber(item.total) }}</td>
                                            </tr>
                                        </table>    
                                    </td>                     
                                </tr> 
                            </tbody>
                            <!-- Table Footer for Totals -->
                            <tfoot>
                                <tr>
                                    <td>
                                        <strong>Total Expenses: </strong>{{ formatIndianNumber(expenses_total) }}
                                    </td>
                                    <td>
                                        <strong>Total Sales: </strong>{{ formatIndianNumber(totalIncome) }}
                                    </td>
                                </tr>
                               
                                <tr>
                                    <td v-if="(totalIncome - expenses_total) > 0" :class="(totalIncome - expenses_total) > 0 ? 'profit' : 'loss'">
                                        <strong>Profit : </strong>{{ formatIndianNumber(totalIncome - expenses_total) }}
                                    </td>  
                                    
                                    <td v-else>
                                    </td>
                                    <td v-if="(totalIncome - expenses_total) < 0" :class="(totalIncome - expenses_total) > 0 ? 'profit' : 'loss'">
                                        <strong>Loss : </strong>{{ formatIndianNumber(totalIncome - expenses_total) }}
                                    </td>  
                                          <td v-else>
                                    </td>                         
                                </tr>
                            </tfoot>
                            
                        </table>
                        
                        
                            <table id="" class="">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Asset Expenses</th>
                                     
                                  
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr>
                                    <td style="align-content: start;">
                                        <table>
                                            
                                          
                                             <tr  v-for="(item, index) in assets_data" :key="item.id">
                                                
                                                    <td>{{ item.group_name }}</td>
                                                    <td>{{ formatIndianNumber(item.total_amount) }}</td>
                                            </tr>
                                        </table>
                                        
                                        </td>
                                                   
                                </tr> 
                            </tbody>
                            <!-- Table Footer for Totals -->
                            <tfoot> 
                                   <tr>  <td>
                                        <strong>Total Assets Expenses: </strong>{{ formatIndianNumber(asset_data) }}
                                    </td> 
                                </tr> 
                            </tfoot>
                            
                        </table>
                        
                    <div>
                        <h1 style="font-weight: bold; font-size: 15px;" >Grand Expenses Total: {{ formatIndianNumber(Number(asset_data) + Number(expenses_total)) }}</h1>
                    </div>



                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Main Content End -->
</template>
<style>
    .profit {
    color: green;
}

.loss {
    color: red;
}

</style>
<style scoped>
.print_heading{
    font-size: 20px;
}
tfoot{
    background: antiquewhite;
    font-size: medium;
    font-weight: 800;
}
tfoot td{
    height: 35px;
}
.print-only {
    display: none;
}
.printonly{
    margin-top: -200px;
        display: none; 
    }

@media print {
    .print-only {
        display: block; /* Show elements for print */
        text-align: center; /* Center alignment as needed */
        font-size: 16px; /* Font size adjustments if needed */
        
    }
    .printonly{
        display: block; 
    }
}


@media print {
    /* Hide unnecessary elements */
    button, select, input,   .header_class, .header, .card-title {
        display: none !important;
    }
    

    /* Adjust the layout */
    body {
        margin: 0;
        padding: 0;
        font-family: Arial, sans-serif;
    }

    /* Receipt container */
    .receipt-container, #printable-content {
        width: 100%;
        padding: 10mm;
        margin: auto;
        border: 1px solid #000;
    }

    /* Add a border and spacing to the table */
    table {
        width: 100%;
        border-collapse: collapse;
    }

    table th, table td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
        font-size: 12px;
        color: black !important; 
    }

    
    table th ,h2{
        background-color: #f2f2f2;
        font-weight: bold;
        color: black!important;
    }

    /* Center titles */
    h1, h2 {
        text-align: center;
        margin: 0 0 10px;
        font-size: 16px;
        font-weight: bold;
    }

    /* Add company branding details */
    #printable-content {
        text-align: center;
    }

    #printable-content h1 {
        font-size: 20px;
    }

    /* Add spacing between sections */
    .section {
        margin-bottom: 20px;
    }

    /* Performance container styling */
    .performance-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .performance-box {
        flex: 1;
        padding: 5px;
        margin: 0 5px;
        border: 1px solid #ddd;
        font-size: 12px;
        text-align: center;
    }

    .performance-box.best {
        background-color: #c8e6c9;
    }

    .performance-box.good {
        background-color: #bbdefb;
    }

    .performance-box.average {
        background-color: #ffe0b2;
    }
}

  
    .salary_input{
        padding: 5px;
        width: 70px;
    }
    .plotname{
        font-size: x-small;
    font-weight: 200;
    background: yellow;
    padding: 0px 2px;
    border-radius: 10px;
    }

    .performance-container {
      display: flex;
      gap: 20px;
    }
    .performance-box {
      padding: 1px;
      border-radius: 8px;
      color: white;
      text-align: center;
      font-weight: bold;
      width: 80px;
    }
    
    .Best1 {
      background-color: green;
    }
    .Good1 {
      background-color: blue;
    }
    .Average1 {
      background-color: orange;
    }

    .best {
  color: green;
}
.good {
  color: blue;
}
.average {
  color: orange;
}
</style>
<script>
import axios from 'axios';

export default {
    name: 'salarySlipReport',
    watch: {
        stocktransferList () { // data used in the table
           this.$nextTick (() => { // wait until data fully updated before re-render new DOM 
             $('.datatable').DataTable().draw();
             this.reinitializeDataTable();
           })
         },
         
     },

     computed: {
        // totalExpenses() {
        //     return this.expenses_data.reduce((total, item) => total + parseFloat(item.totalamount || 0), 0).toFixed(2);
        // },
         totalIncome() {
             return this.income_data.reduce((total, item) => total + parseFloat(item.total || 0), 0).toFixed(2);
         },


            selectedMukkadamName() {
                const selected = this.ledgerList.find(
                    (item) => item.id === this.filter.leadger
                );
                return selected ? selected.name : "No Ledger Selected";
            },

        



    },



    data() {
        const today = new Date().toISOString().split('T')[0];
        return {
            salslipList: [],
            asset_data:0,
            branchList:[],
            ledgerList:[],
            expenses_total:[],
            filteredsalslipList: [],
            assets_data:[],
            stocktransferList:[],
            datatable: null,
            startDate: today,
            endDate: today,
            totalAmount: 0,
            isPrint: false,
            filter: {
                leadger:0,
                fromdate: null,
                todate:null,
        },

        expenses_data:[],
        income_data:[]
        };
    },
    mounted() {
        this.getBasics();
    },
    watch: {
        stocktransferList() {
            this.$nextTick(() => {
                $('.datatable').DataTable().draw();
           
            });
        },
    },
    methods: {
        formatIndianNumber(value) {
      return new Intl.NumberFormat('en-IN').format(value);
    },
           printReceipt() {
               this.isPrint=true;
      window.print();
    },

        getSalarySlipDetails(id) {
            window.open('/salaryslipdetails?q=' + id, '_blank');
        },

        exportCSV() {
            let csvContent = "Expenses,Amount\n";

            // Expenses rows
            this.expenses_data.forEach(item => {
                csvContent += `${item.group_name},${item.total_amount},\n`;
            });
            
            csvContent += `\n\nIncome,Total\n`;
            // Income rows
            this.income_data.forEach(item => {
                csvContent += `${item.product_name},${item.total}\n`;
            });
            csvContent += `\n\nAsset,Expenses\n`;
            
            // Income rows
            this.assets_data.forEach(item => {
                csvContent += `${item.group_name},${item.total_amount}\n`;
            });
            // Create a hidden link element to trigger the download
            const link = document.createElement('a');
            link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent));
            link.setAttribute('download', 'expenses_income_report.csv');

            // Append the link, trigger the click to download, then remove the link
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        


    },

    formatDate(date) {
    if (!date) return "";  // Return empty string if date is missing or null
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";  // Return empty if invalid date
    return d.toLocaleDateString();  // Format the date as per your requirement
},



        calculateAmount(bhade, rate) {
            return (bhade * rate).toFixed(2);
        },
        async getBasics() {
            const self = this;
            axios.post('getexpensesreport').then(function (response) {
                self.salslipList = response.data.salslipList;
                self.ledgerList = response.data.ledgerlist;
                self.stocktransferList = response.data.products;
                self.original_stocktransferList = response.data.products;
            }).then(() => {


                $("#from_branch").select2({
                                        width: '220px',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Ledger Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {

                                        //alert(event.target.value);
                                            self.filter.leadger=event.target.value; 
                                            //self.productsList.slice(0); 
                                            // self.getBasicFilteredData(event.target.value);        
                                            
                                        });



            });
        },
 
        async getBasicFilteredData(ledgerid) {


            
            if (!this.filter.leadger) {
                        alert("Please select ledger first.");
                        return;
                    }

    this.isLoading = true; // Show the spinner while filtering
       var self=this;
         axios.post('getledger',{filter:self.filter}).then(function (response) {
                    self.expenses_data=response.data.expenses_data;
                    self.expenses_total=response.data.expenses_total;
                    self.income_data = response.data.income_data; 
                    self.asset_data = response.data.asset_data; 
                    self.assets_data = response.data.assets_data; 
                    
                //  self.employees=response.data.userDetails;
                //  self.branchList = response.data.branchLists;
                }).then(()=>{ 

                    // $("#branch_name").select2({
                    //                     width: '80%',
                    //                     dropdownAutoWidth : true,
                    //                     placeholder:"Search Branch Here...",
                    //                 "language": {
                    //                             "noResults": function(){
                    //                                 return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                    //                             }
                    //                         },
                    //                             escapeMarkup: function (markup) {
                    //                                 return markup;
                    //                             }
                    //                 }).on('change', function (event) {
                    //                         self.getBasicFilteredData(event.target.value); 
                    //                            $('.datatable').DataTable().destroy();
                                            
                    //                     });

                }).finally(function () {
                    self.isLoading = false; // Hide the spinner after the request

                    });;
                    
  },




      
        filterPurchases() {
            let filteredList = this.stocktransferList;

            // Apply date filtering
            if (this.startDate) {
                filteredList = filteredList.filter(item => new Date(item.iddate) >= new Date(this.startDate));
            }

            if (this.endDate) {
                filteredList = filteredList.filter(item => new Date(item.iddate) <= new Date(this.endDate));
            }
        
            $('.datatable').DataTable().destroy();   
            
            this.stocktransferList = filteredList;
        },





        filterSalarySlip() {
            if (this.datatable) {
                this.datatable.destroy();
            }

            let filteredList = this.salslipList;
            if (this.startDate) {
                filteredList = filteredList.filter(item => new Date(item.entrydate) >= new Date(this.startDate));
            }

            if (this.endDate) {
                filteredList = filteredList.filter(item => new Date(item.entrydate) <= new Date(this.endDate));
            }

            this.filteredsalslipList = filteredList;

            this.$nextTick(() => {
                this.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });
        },
        filterByParentName(parentName) {
            if (this.datatable) {
                this.datatable.destroy();
            }

            this.filteredsalslipList = this.salslipList.filter(item => item.parent_name === parentName);

            this.$nextTick(() => {
                this.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });

          
        },

        print_invoice(id) {
            window.open('/stocktransferPrints?q=' + id, '_blank');
        },
      
    }
}
</script>
